class ShopLook extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.listeners.add(this.els.backdrop.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    const bodyEl = this.els.body.element
    const contentEl = this.els.items.element
    const currentState = this.getAttribute('aria-expanded') === 'true'

    bodyEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    this.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('shop-look')) {
  customElements.define('shop-look', ShopLook)
}
